import { render, staticRenderFns } from "./CreateTrainHeader.vue?vue&type=template&id=15e670c6"
import script from "./CreateTrainHeader.vue?vue&type=script&lang=js"
export * from "./CreateTrainHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports